import { throwErrorMsg } from "../../utils/throwErrorMsg"

export const file = {
  create({ path = "", name, pathType = 1, content }) {
    throwErrorMsg("file.create")
  },
  append({ path = "", name, pathType = 1, content }) {
    throwErrorMsg("file.append")
  },
  read({ path = "", name, pathType = 1 }) {
    throwErrorMsg("file.read")
  },
  exists({ path = "", name, pathType = 1 }) {
    throwErrorMsg("file.exists")
  },
  delete({ path = "", name, pathType = 1 }) {
    throwErrorMsg("file.delete")
  },
} as FileDSL
